import { render, staticRenderFns } from "./section-cafe.vue?vue&type=template&id=2c399e90&scoped=true"
import script from "./section-cafe.vue?vue&type=script&lang=js"
export * from "./section-cafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c399e90",
  null
  
)

export default component.exports